import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown, DBTextField, DBIntField, DBCheckBox, RedoButton, StatusGood } from '_components';
import styles from './Common.module.css';
import { codeValidForAdmit } from '_helpers';


class AlPhysPerfTestRow extends React.Component {

    remove() {
        this.props.removeChildRow(this.props.noteId, 'MLSPECIALTYTESTS', 'XLSZ', this.props.test.XLSZNO);
    }

    componentDidUpdate() {
        if (this.props.test.XLSZPENDING === null && !this.props.trtValid) {
            this.props.updateBitField(this.props.noteId, 'MLSPECIALTYTESTS', 'XLSZNO', this.props.test.XLSZNO, 'XLSZPENDING', true);
        }
    }

    handleChange(event) {
        if (event.target.value === "-1" || parseInt(event.target.value) !== this.props.test.XLSZMDNO) {
            this.props.clearField(this.props.noteId, 'MLSPECIALTYTESTS', 'XLSZNO', this.props.test.XLSZNO, 'XLSZPENDING');
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    confirmPending() {
        this.props.updateBitField(this.props.noteId, 'MLSPECIALTYTESTS', 'XLSZNO', this.props.test.XLSZNO, 'XLSZPENDING', false);
    }

    handlePerformed(val) {
        if (!this.props.onAssessment && val === true) {
            this.props.updateBitField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLPERFTEST', true);
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    handleTimeChange() {
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    render() {
        return (
            <span>
                <div className={this.props.test.XLSZPERFORMED ? styles.row_performed : styles.row}>
                    <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.remove()} />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBDropDown
                            field='XLSZMDNO'
                            noteId={this.props.noteId}
                            entity='MLSPECIALTYTESTS'
                            entityKeyColumn='XLSZNO'
                            entityKeyValue={this.props.test.XLSZNO}
                            className={this.props.test.XLSZPERFORMED && !this.props.test.XLSZMDNO ? styles.col1_performed : styles.col1}
                            customOptions={this.props.activities}
                            onChange={(event) => this.handleChange(event)}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>

                        <DBTextField
                            noteId={this.props.noteId}
                            entity='MLSPECIALTYTESTS'
                            entityKeyColumn='XLSZNO'
                            entityKeyValue={this.props.test.XLSZNO}
                            field='XLSZACTIVITY'
                            className={this.props.test.XLSZPERFORMED && !this.props.test.XLSZACTIVITY ? styles.col2_wide_performed : styles.col2_wide}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>

                        <DBIntField
                            noteId={this.props.noteId}
                            entity='MLSPECIALTYTESTS'
                            entityKeyColumn='XLSZNO'
                            entityKeyValue={this.props.test.XLSZNO}
                            field='XLSZTIME'
                            min={0}
                            className={this.props.test.XLSZPERFORMED && !this.props.test.XLSZTIME ? styles.col3_narrow_performed : styles.col3_narrow}
                            onClick={() => this.handleTimeChange()}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>

                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='MLSPECIALTYTESTS'
                            entityKeyColumn='XLSZNO'
                            entityKeyValue={this.props.test.XLSZNO}
                            field='XLSZPERFORMED'
                            className={styles.col4}
                            disabled={this.props.performedDisabled}
                            onClick={(val) => this.handlePerformed(val)}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <span className={styles.col5} />
                    </div>
                    {this.props.prevVisit &&
                        <div className={styles.cell_wrapper}>
                            <span className={styles.col6}>
                                <RedoButton size='extra-small' title='Performed during previous visit' />
                            </span>
                        </div>
                    }
                </div>
                {this.props.test.XLSZPENDING &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.warning_msg}>This treatment code is not covered by the patient's payer and will <b>not</b> be reimbursed.  Do you wish to add it anyway?</span>
                        <span className={styles.yes_button} >
                            <StatusGood size='extra-small' title='Yes' onClick={() => this.confirmPending()} />
                        </span>
                        <span className={styles.no_button} >
                            <CancelButton size='extra-small' title='No' onClick={() => this.remove()} />
                        </span>
                    </div>
                }
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isFederal = state.entities.admissions[epno].isFederal;
    let isWc = state.entities.admissions[epno].isWc;
    let isAuto = state.entities.admissions[epno].isAuto;
    let isOther = (isPedsEnabled && !isPeds && !isFederal && !isWc && !isAuto) || (!isPedsEnabled && !isFederal && !isWc && !isAuto) ? true : false;
    let test = state.entities.notes.MLSPECIALTYTESTS[ownprops.id];
    let prevVisit = Object.keys(state.entities.notes.MLSPECIALTYTESTSPREV)
        .find(key => (state.entities.notes.MLSPECIALTYTESTSPREV[key].NoteId === noteId &&
            state.entities.notes.MLSPECIALTYTESTSPREV[key].XLSZMDNO === test.XLSZMDNO &&
            state.entities.notes.MLSPECIALTYTESTSPREV[key].XLSZACTIVITY === test.XLSZACTIVITY
        )) !== undefined ? true : false;
    let code = undefined;
    let trtValid = true;
    if (test.XLSZMDNO !== null) {
        code = state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[
            Object.keys(state.entities.masterData.MLMASTERSTANDARDIZEDTESTS)
                .find(key => (state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[key].SZNO === test.XLSZMDNO))
        ].SZCODE;
        trtValid = codeValidForAdmit(epno, code);
    }

    let activities = state.entities.masterData.MLMASTERSTANDARDIZEDTESTS ?
        Object.keys(state.entities.masterData.MLMASTERSTANDARDIZEDTESTS)
            .filter(key => {
                if ((isPedsEnabled && isPeds && state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[key].SZPEDS) ||
                    (isFederal && state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[key].SZMC) ||
                    (isWc && state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[key].SZWC) ||
                    (isAuto && state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[key].SZAUTO) ||
                    (isOther && state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[key].SZOTHER)) {
                    return true;
                } else {
                    return false;
                }
            })
            .sort((a, b) => state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[a].SZNAME.localeCompare(state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[b].SZNAME))
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[key].SZNO,
                    value: state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[key].SZNAME + ' - ' + state.entities.masterData.MLMASTERSTANDARDIZEDTESTS[key].SZCODE
                }
            )) : [];
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let onAssessment = state.entities.notes.PTPLAN[plno] && state.entities.notes.PTPLAN[plno].PLPERFTEST ? true : false;
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;
    let performedDisabled = noteType === 3 || noteType === 4 ? true : false;

    return {
        noteId: noteId,
        xlno: xlno,
        test: test,
        activities: activities,
        trtValid: trtValid,
        prevVisit: prevVisit,
        plno,
        onAssessment,
        computedChargesVisible,
        performedDisabled
    };
}

const connectedAlPhysPerfTestRow = connect(mapStateToProps, mapDispatchToProps)(AlPhysPerfTestRow);
export { connectedAlPhysPerfTestRow as AlPhysPerfTestRow };

